/**
 * オフライン状態バナー
 * ネットワーク接続が切れている間だけ表示する常設バナーです
 */

import React from 'react';
import { Text, View } from './WebPrimitives';
import useNetworkStatus from '../hooks/useNetworkStatus';

/**
 * オフライン状態バナー
 * @returns {JSX.Element | null} オフライン時のみ表示するバナー
 */
const OfflineStatusBanner = () => {
  /** ネットワーク接続状態 */
  const { isOnline } = useNetworkStatus();

  if (isOnline) {
    return null;
  }

  return (
    <View
      className="mb-3 rounded-none border-2 border-app-quest-night bg-app-quest-gold px-3 py-2"
      testID="offline-status-banner"
    >
      <Text className="text-center text-xs font-extrabold text-app-quest-night">
        ⚠ オフラインです。電波が回復すると自動で再開します。
      </Text>
    </View>
  );
};

export default OfflineStatusBanner;
